import { useFetch } from './useFetch'

export const useVagaService = () => {
  const fetch = useFetch()

  const listarVagasAsync = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/vaga`)
      return response.data.vagas
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarVaga = async (id, setVaga, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/vaga/${id}`)
      setVaga(response.data.vaga)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarVagaAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/vaga/${id}`)
      return response.data.vaga
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarVagasDisponiveisAsync = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/vaga/disponiveis/todas`)
      return response.data.vagas
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarVaga = async (dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosDaVaga = {
        id_tipo_exame: dados.tipoExame ? dados.tipoExame.id : null,
        data: dados.data,
      }
      await fetch.postOpen('/vaga', dadosDaVaga)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const excluirVaga = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.del(`/vaga/${id}`)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    listarVagasAsync,
    listarVagaAsync,
    listarVaga,
    cadastrarVaga,
    excluirVaga,
    listarVagasDisponiveisAsync,
  }
}
